import DescricaoID from "@/models/lists/descricao-id.model";
import HeaderModel from "@/models/headers.model";

class Listas {

    headersUsuarios: Array<HeaderModel>;
    headersClientes: Array<HeaderModel>;
    headersContatos: Array<HeaderModel>;
    headersReceberAll: Array<HeaderModel>;
    headersReceberDefault: Array<HeaderModel>;
    headersSinalizacao: Array<HeaderModel>;
    headersNota: Array<HeaderModel>;
    tiposPessoa: Array<DescricaoID>;
    tiposContatos: Array<DescricaoID>;
    classificacoesCliente: Array<DescricaoID>;
    classificacoesTitulo: Array<DescricaoID>;
    esferas: Array<DescricaoID>;
    empresas: Array<DescricaoID>;
    status_pagamento: Array<DescricaoID>;
    pagamento_atraso: Array<DescricaoID>;
    tiposDatas: Array<DescricaoID>;
    periodos: Array<DescricaoID>;
    setores: Array<DescricaoID>;
    marcadores: Array<DescricaoID>;
    headersContratos: Array<HeaderModel>;

    constructor() {
        this.headersUsuarios = this.populaHeadersUsuarios();
        this.headersClientes = this.populaHeadersClientes();
        this.headersContatos = this.populaHeadersContatos();
        this.headersReceberAll = this.populaAllHeadersReceber();
        this.headersReceberDefault = this.populaHeadersReceberDefaults();
        this.headersSinalizacao = this.populaHeadersSinalizacao();
        this.headersNota = this.populaHeadersNota();
        this.tiposPessoa = this.populaTiposPessoas();
        this.tiposContatos = this.populaTiposContatos();
        this.classificacoesCliente = this.populaClassificacoesCliente();
        this.classificacoesTitulo = this.populaClassificacoesTitulo();
        this.esferas = this.populaEsferas();
        this.empresas = this.populaEmpresas();
        this.status_pagamento = this.populaStatusPagamento();
        this.pagamento_atraso = this.populaPagamentoAtraso();
        this.tiposDatas = this.populaTiposDatas();
        this.periodos = this.populaPeriodos();
        this.setores = this.populaSetores();
        this.marcadores = this.populaMarcadores();
        this.headersContratos = this.populaHeadersContratos();
    }

    populaHeadersUsuarios() {
        let headers: Array<HeaderModel> = [];
        headers.push(new HeaderModel(1, 'Nome', 'left', false, 'name'));
        headers.push(new HeaderModel(2, 'E-mail', 'left', false, 'email'));
        headers.push(new HeaderModel(3, 'Ação', 'center', false, 'action'));
        return headers;
    }

    populaHeadersClientes() {
        let headers: Array<HeaderModel> = [];
        headers.push(new HeaderModel(1, 'Código', 'center', false, 'codigo'));
        headers.push(new HeaderModel(2, 'Razão Social', 'left', false, 'razao_social'));
        headers.push(new HeaderModel(3, 'Nome Fantasia', 'left', false, 'nome_fantasia'));
        headers.push(new HeaderModel(4, 'Tipo Pessoa', 'center', false, 'tipo_pessoa'));
        headers.push(new HeaderModel(5, 'UF', 'center', false, 'estado'));
        headers.push(new HeaderModel(6, 'CNPJ/CPF', 'center', false, 'cpf_cnpj'));
        headers.push(new HeaderModel(7, 'Ação', 'center', false, 'action'));
        return headers;
    }

    populaHeadersContatos() {
        let headers: Array<HeaderModel> = [];
        headers.push(new HeaderModel(1, 'Tipo Contato', 'center', false, 'tipo_contato'));
        headers.push(new HeaderModel(2, 'Descrição', 'center', false, 'descricao'));
        headers.push(new HeaderModel(3, 'Responsável', 'center', false, 'responsavel'));
        headers.push(new HeaderModel(4, 'Setor', 'center', false, 'setor'));
        headers.push(new HeaderModel(5, 'Ação', 'center', false, 'action'));
        return headers;
    }

    populaHeadersReceberDefaults() {
        let headers: Array<HeaderModel> = [];
        headers.push(new HeaderModel(1, 'Empresa', 'center', false, 'Empresa', '', 'sticky-header primary'));
        headers.push(new HeaderModel(2, 'Nota', 'center', false, 'Núm_NF', '', 'sticky-header primary'));
        headers.push(new HeaderModel(3, 'Setor Atual', 'center', false, 'posicao_atual_regua', '', 'sticky-header primary'));
        headers.push(new HeaderModel(4, 'Cód. Cliente', 'center', false, 'Cód_Fornecedor', '', 'sticky-header primary'));
        headers.push(new HeaderModel(5, 'Cliente', 'left', false, 'Nome_Fornecedor', '450px', 'sticky-header primary'));
        headers.push(new HeaderModel(6, 'Esfera', 'center', false, 'Esfera', '', 'sticky-header primary'));
        headers.push(new HeaderModel(7, 'UF', 'center', false, 'UF', '', 'sticky-header primary'));
        headers.push(new HeaderModel(8, 'Contrato', 'center', false, 'codigo_contrato', '', 'sticky-header primary'));
        headers.push(new HeaderModel(14, 'Valor Nota', 'center', false, 'Valor_parcela', '', 'sticky-header primary'));
        headers.push(new HeaderModel(16, 'Data Emissão', 'center', false, 'Data_emissão', '', 'sticky-header primary'));
        headers.push(new HeaderModel(18, 'Data Pagamento', 'center', false, 'Data_quitação', '', 'sticky-header primary'));
        headers.push(new HeaderModel(19, 'Status Pgto.', 'center', false, 'status_pagamento', '', 'sticky-header primary'));
        return headers;
    }

    populaHeadersSinalizacao() {
        let headers: Array<HeaderModel> = [];
        headers.push(new HeaderModel(1, '', '', false, 'data-table-select', '', 'sticky-header primary'));
        headers.push(new HeaderModel(2, 'Empresa', 'left', false, 'Empresa', '155px', 'sticky-header primary'));
        headers.push(new HeaderModel(3, 'Nota', 'center', false, 'Núm_NF', '', 'sticky-header primary'));
        headers.push(new HeaderModel(4, 'Setor', 'center', false, 'posicao_atual_regua', '', 'sticky-header primary'));
        headers.push(new HeaderModel(5, 'Contrato', 'center', false, 'codigo_contrato', '', 'sticky-header primary'));
        headers.push(new HeaderModel(6, 'Pregão', 'center', false, 'num_pregao', '', 'sticky-header primary'));
        headers.push(new HeaderModel(7, 'Marcador', 'center', false, 'marcador_contrato', '', 'sticky-header primary'));
        headers.push(new HeaderModel(8, 'Classificação', 'center', false, 'classificacao', '', 'sticky-header primary'));
        headers.push(new HeaderModel(9, 'Empenho', 'center', false, 'num_empenho', '', 'sticky-header primary'));
        headers.push(new HeaderModel(10, 'Documento', 'center', false, 'Documento', '', 'sticky-header primary'));
        headers.push(new HeaderModel(11, 'Valor', 'center', false, 'Valor_parcela', '', 'sticky-header primary'));
        headers.push(new HeaderModel(12, 'Emissão', 'center', false, 'Data_emissão', '', 'sticky-header primary'));
        headers.push(new HeaderModel(13, 'Período', 'center', false, 'range_tipo', '', 'sticky-header primary'));
        return headers;
    }

    populaHeadersNota() {
        let headers: Array<HeaderModel> = [];
        headers.push(new HeaderModel(1, 'Empresa', 'center', false, 'Empresa'));
        headers.push(new HeaderModel(2, 'Nota', 'center', false, 'Núm_NF'));
        headers.push(new HeaderModel(3, 'Cód. Cliente', 'center', false, 'Cód_Fornecedor'));
        headers.push(new HeaderModel(4, 'Cliente', 'left', false, 'Nome_Fornecedor'));
        headers.push(new HeaderModel(5, 'Esfera', 'center', false, 'Esfera'));
        headers.push(new HeaderModel(6, 'UF', 'center', false, 'UF'));
        headers.push(new HeaderModel(7, 'Cidade', 'center', false, 'Cidade'));
        headers.push(new HeaderModel(8, 'Valor Nota', 'center', false, 'Valor_parcela'));
        headers.push(new HeaderModel(9, 'Ação', 'center', false, 'action'));
        return headers;
    }

    populaAllHeadersReceber() {
        let headers: Array<HeaderModel> = [];
        headers.push(new HeaderModel(1, 'Empresa', 'center', false, 'Empresa', '', 'sticky-header primary'));
        headers.push(new HeaderModel(2, 'Nota', 'center', false, 'Núm_NF', '', 'sticky-header primary'));
        headers.push(new HeaderModel(3, 'Setor Atual', 'center', false, 'posicao_atual_regua', '', 'sticky-header primary'));
        headers.push(new HeaderModel(4, 'Cód. Cliente', 'center', false, 'Cód_Fornecedor', '', 'sticky-header primary'));
        headers.push(new HeaderModel(5, 'Cliente', 'left', false, 'Nome_Fornecedor', '', 'sticky-header primary'));
        headers.push(new HeaderModel(6, 'Esfera', 'center', false, 'Esfera', '', 'sticky-header primary'));
        headers.push(new HeaderModel(7, 'UF', 'center', false, 'UF', '', 'sticky-header primary'));

        headers.push(new HeaderModel(8, 'Contrato', 'center', false, 'codigo_contrato', '', 'sticky-header primary'));
        headers.push(new HeaderModel(9, 'Marcador Contrato', 'center', false, 'marcador_contrato', '', 'sticky-header primary'));
        headers.push(new HeaderModel(10, 'Nº Pregão', 'center', false, 'num_pregao', '', 'sticky-header primary'));
        headers.push(new HeaderModel(11, 'Classificação', 'center', false, 'classificacao', '', 'sticky-header primary'));
        headers.push(new HeaderModel(12, 'Nº Empenho', 'center', false, 'num_empenho', '', 'sticky-header primary'));

        headers.push(new HeaderModel(13, 'Nº Doc', 'center', false, 'Documento', '', 'sticky-header primary'));
        headers.push(new HeaderModel(14, 'Valor Nota', 'center', false, 'Valor_parcela', '', 'sticky-header primary'));
        headers.push(new HeaderModel(15, 'Valor Depósito', 'center', false, 'Valor_recebido', '', 'sticky-header primary'));
        headers.push(new HeaderModel(16, 'Data Emissão', 'center', false, 'Data_emissão', '', 'sticky-header primary'));
        headers.push(new HeaderModel(17, 'Data Vencimento', 'center', false, 'Data_vencimento', '', 'sticky-header primary'));
        headers.push(new HeaderModel(18, 'Data Pagamento', 'center', false, 'Data_quitação', '', 'sticky-header primary'));
        headers.push(new HeaderModel(19, 'Status Pgto.', 'center', false, 'status_pagamento', '', 'sticky-header primary'));
        headers.push(new HeaderModel(20, 'Banco', 'center', false, 'Nome_cta_débito', '', 'sticky-header primary'));
        headers.push(new HeaderModel(21, 'Pgto. Atrasado?', 'center', false, 'pagamento_atraso', '', 'sticky-header primary'));
        return headers;
    }

    populaTiposDatas() {
        let headers: Array<DescricaoID> = [];
        headers.push(new DescricaoID('Data_emissão', 'Data de Emissão'));
        headers.push(new DescricaoID('Data_vencimento', 'Data de Vencimento'));
        headers.push(new DescricaoID('Data_quitação', 'Data de Pagamento'));
        return headers;
    }

    populaTiposPessoas() {
        let headers: Array<DescricaoID> = [];
        headers.push(new DescricaoID('J', 'Pessoa Jurídica'));
        headers.push(new DescricaoID('F', 'Pessoa Física'));
        return headers;
    }

    populaTiposContatos() {
        let headers: Array<DescricaoID> = [];
        headers.push(new DescricaoID('TELEFONE', 'Telefone'));
        headers.push(new DescricaoID('EMAIL', 'E-mail'));
        headers.push(new DescricaoID('WHATSAPP', 'WhatsApp'));
        return headers;
    }

    populaClassificacoesCliente() {
        let headers: Array<DescricaoID> = [];
        headers.push(new DescricaoID('PARTICULAR', 'Particular'));
        headers.push(new DescricaoID('PUBLICO', 'Público'));
        return headers;
    }

    populaClassificacoesTitulo() {
        let headers: Array<DescricaoID> = [];
        headers.push(new DescricaoID('OPME', 'OPME'));
        headers.push(new DescricaoID('DESCARTÁVEL', 'DESCARTÁVEL'));
        headers.push(new DescricaoID('MISTO', 'MISTO'));
        headers.push(new DescricaoID('PARTICULAR', 'PARTICULAR'));
        return headers;
    }

    populaEsferas() {
        let headers: Array<DescricaoID> = [];
        headers.push(new DescricaoID('MUNICIPAL', 'Municipal'));
        headers.push(new DescricaoID('ESTADUAL', 'Estadual'));
        headers.push(new DescricaoID('FEDERAL', 'Federal'));
        headers.push(new DescricaoID('PARTICULAR', 'Particular'));
        return headers;
    }

    populaEmpresas() {
        let headers: Array<DescricaoID> = [];
        headers.push(new DescricaoID('Nexomed', 'Nexomed'));
        headers.push(new DescricaoID('BML', 'BML'));
        return headers;
    }

    populaStatusPagamento() {
        let headers: Array<DescricaoID> = [];
        headers.push(new DescricaoID('PAGO', 'Pago'));
        headers.push(new DescricaoID('PENDENTE', 'Pendente'));
        return headers;
    }

    populaPagamentoAtraso() {
        let headers: Array<DescricaoID> = [];
        headers.push(new DescricaoID('OK', 'OK'));
        headers.push(new DescricaoID('AGUARDANDO', 'Aguardando'));
        headers.push(new DescricaoID('ATRASADO', 'Atrasado'));
        return headers;
    }

    populaPeriodos() {
        let headers: Array<DescricaoID> = [];
        headers.push(new DescricaoID('1', '0-15'));
        headers.push(new DescricaoID('2', '15-30'));
        headers.push(new DescricaoID('3', '30-45'));
        headers.push(new DescricaoID('4', '45-90'));
        headers.push(new DescricaoID('5', '90-120'));
        headers.push(new DescricaoID('6', '120-150'));
        headers.push(new DescricaoID('7', '360-720'));
        headers.push(new DescricaoID('8', '+ 720'));
        return headers;
    }

    populaSetores() {
        let headers: Array<DescricaoID> = [];
        headers.push(new DescricaoID('1', 'Envio/Cirurgia'));
        headers.push(new DescricaoID('2', 'Alm/B.C Entrega'));
        headers.push(new DescricaoID('3', 'Alm/B.C Processo'));
        headers.push(new DescricaoID('4', 'Cont. Liquidação'));
        headers.push(new DescricaoID('5', 'Tesour. Pagamento'));
        return headers;
    }

    populaMarcadores() {
        let headers: Array<DescricaoID> = [];
        headers.push(new DescricaoID('ESTRUTURANTE', 'ESTRUTURANTE'));
        headers.push(new DescricaoID('R. VENDAS', 'R. VENDAS'));
        headers.push(new DescricaoID('R. CONSIGNADO', 'R. CONSIGNADO'));
        headers.push(new DescricaoID('PARTICULAR', 'PARTICULAR'));
        return headers;
    }

    populaHeadersContratos() {
        let headers: Array<HeaderModel> = [];
        headers.push(new HeaderModel(1, 'Código', 'center', false, 'codigo'));
        headers.push(new HeaderModel(2, 'Edital', 'center', false, 'edital'));
        headers.push(new HeaderModel(3, 'Tipo', 'center', false, 'tipo'));
        headers.push(new HeaderModel(4, 'Classificação', 'center', false, 'classificacao'));
        headers.push(new HeaderModel(7, 'Ação', 'center', false, 'action'));
        return headers;
    }

}

export default Listas;
